import React from 'react';

export const VPNDialogContext = React.createContext({});
